import { getFacebookParams } from 'nove8/helpers/getFacebookParams'
import { subscriptionsApi } from 'nove8/api'
import { ProcessingKey } from 'nove8/constants/root-constants'
import { APP_NAME } from 'root-constants'
import { goTo } from 'route-history'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'
import { fetchGeoData } from './fetchGeoData'

export const createLead = async (): Promise<void> => {
  useZustandStore.getState().startProcessing(ProcessingKey.CREATE_LEAD)

  const initialCohort = useZustandStore.getState().initialCohort
  const searchParams = new URLSearchParams(window.location.search)
  const language = useZustandSessionStore.getState().language
  const inputEmail = useZustandStore.getState().inputEmail
  const { fbp, fbc } = getFacebookParams()

  const geoDataResponse = await fetchGeoData()

  if (geoDataResponse?.region) {
    useZustandStore.setState({ geoRegion: geoDataResponse.region })
  }
  if (geoDataResponse?.city) {
    useZustandStore.setState({ geoCity: geoDataResponse.city })
  }

  const attribution = {
    fbp,
    fbc,
    utmSource: searchParams.get('utm_source'),
    utmMedium: searchParams.get('utm_medium'),
    utmCampaign: searchParams.get('utm_campaign'),
    utmContent: searchParams.get('utm_content'),
    utmTerm: searchParams.get('utm_term'),
    geo: geoDataResponse
      ? {
          city: geoDataResponse.city,
          country: geoDataResponse.country,
          region: geoDataResponse.region,
          postalCode: geoDataResponse.postalCode,
          ip: geoDataResponse.ip,
          timezone: geoDataResponse.timezone,
        }
      : null,
  }

  const response = await subscriptionsApi.createLead({
    appName: APP_NAME,
    attribution,
    cohort: initialCohort,
    email: inputEmail || null,
    locale: language,
  })

  if (response && response.data) {
    const lead = response.data

    useZustandStore.setState({ lead })
    useZustandGlobalLocalStore.setState((state) => ({
      previousLeadId: state.previousLeadId || lead.id,
    }))

    // Redirect to the default page in case user started from another page
    goTo(`/?${searchParams.toString()}`)
  }

  useZustandStore.getState().stopProcessing(ProcessingKey.CREATE_LEAD)
}
